// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"u6-z"};